@if (config()) {
  <div class="parameter-input-config">
    <mat-form-field
      class="parameter-input-config__field without-subscript small-form-field"
      appearance="outline"
    >
      @if (!hideLabel()) {
        <mat-label>{{ parameterTitle }}</mat-label>
      }
      @if (config().parameter.value === 'UNSIGNED_INT') {
        <input
          [value]="factoredValue"
          [disabled]="disabled()"
          type="number"
          matInput
          [min]="getMin()"
          [max]="getMax()"
          (change)="onChange($event, config())"
          [step]="step"
          [attr.data-testid]="'parameter-input-' + config().parameterId"
        />
      }
      @if (config().parameter.value !== 'UNSIGNED_INT') {
        <input
          [value]="factoredValue"
          [disabled]="disabled()"
          matInput
          (change)="onChange($event, config())"
          [attr.data-testid]="'parameter-input-' + config().parameterId"
        />
      }
      <span matTextSuffix>{{ unit }}</span>
    </mat-form-field>

    @if (config().parameter.description && showInfo()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            class="parameter-input-config__icon"
            color="primary"
            [matTooltip]="config().parameter.description"
            >info_outline
          </mat-icon>
        </button>
      </div>
    }
    @if (!disabled()) {
      @if (value() && !readonly() && hasDelete()) {
        <div class="small-icon-button-wrapper">
          <button mat-icon-button>
            <mat-icon
              (click)="onClickRemove()"
              class="parameter-input-config__close"
              color="warn"
              matTooltip="Discard changes"
              >close
            </mat-icon>
          </button>
        </div>
      }
      @if (value() && !readonly() && hasUndo()) {
        <div class="small-icon-button-wrapper">
          <button mat-icon-button>
            <mat-icon
              (click)="onClickUndo()"
              class="parameter-input-config__close"
              color="warn"
              matTooltip="Discard changes"
              >close
            </mat-icon>
          </button>
        </div>
      }
      @if (hasClose()) {
        <div class="small-icon-button-wrapper">
          <button mat-icon-button>
            <mat-icon (click)="onClickClose()" matTooltip="Close">close</mat-icon>
          </button>
        </div>
      }
      @if (showReset()) {
        <div class="small-icon-button-wrapper">
          <button
            mat-icon-button
            (click)="onResetToFactory()"
            [matTooltip]="resetToFactoryTooltip()"
          >
            <mat-icon color="warn">replay</mat-icon>
          </button>
        </div>
      }
    }
  </div>
}
